<template>
  <div id="app" :class="show.isPhone ? 'is-phone' : 'is-pc'">
    <router-view :key="this.$route.path"></router-view>
    <div class="is-pc" v-if="!show.isPhone">
      <el-backtop>
        <div class="goTop flex align-center justify-center">
          <div class="iconfont icon-e619 color-white size25"></div>
        </div>
      </el-backtop>
    </div>
    <div class="is-phone" v-if="show.isPhone">
      <el-backtop :right="show.isRight">
        <div class="goTop flex align-center justify-center">
          <div class="iconfont icon-e619 color-white size25"></div>
        </div>
      </el-backtop>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        show:{
          isPhone:false,
          isRight:0,
          // topShow:false
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        this.show.isPhone = true
      } else {
        this.show.isPhone = false
      }
      // window.addEventListener('scroll', this.handleScroll, true)
    },
    methods: {
      // 判断手机还是pc
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue